import { render, staticRenderFns } from "./ProcessParcelas.vue?vue&type=template&id=75bc2652"
import script from "./ProcessParcelas.vue?vue&type=script&lang=js"
export * from "./ProcessParcelas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports